import Dashboard from '../containers/dashboard'
import BankingPartnersDetailsManagement from '../containers/banking-partner-details-management'

const BankingPartnersDetails = () => {
  return (
    <Dashboard>
      <BankingPartnersDetailsManagement />
    </Dashboard>
  )
}

export default BankingPartnersDetails
